import classes from '@/components/Shares/Progress.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Avatar, Box, Divider, Group, Image, NumberFormatter, Progress, Text, rem } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import styles from './UserInfoCard.module.css';
export const UserInfoCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  return <Box p={{
    base: 10,
    sm: 20
  }} className={styles.box} mb={14}>
      <Group justify="space-between">
        <Group gap={10}>
          <Avatar src="/assets/user_avatar.png" size={32} variant="transparent" />
          <Box>
            <Text fz={13} className={gunterzBold.className}>
              {i18n._('@bagholder1')}
            </Text>
            <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
              {i18n._('VERIFIED LVL 3')}
            </Text>
          </Box>
        </Group>
        <ActionIcon size="xl" classNames={{
        root: styles.btnIcon
      }} onClick={() => setOpenModal(MODAL.PROFILE)}>
          <IconPencil />
        </ActionIcon>
      </Group>

      <Divider size="xs" my="lg" classNames={styles} />

      <Box pt={60}>
        <Group justify="space-between">
          <Text fz={{
          base: 12,
          sm: 13
        }} c="var(--text-prime)" fw={700}>
            <NumberFormatter value={38577} thousandSeparator="," decimalSeparator="." />
          </Text>
          <Text fz={{
          base: 12,
          sm: 13
        }} c="var(--text-dark)" fw={700}>
            <NumberFormatter value={50000} thousandSeparator="," decimalSeparator="." />
          </Text>
        </Group>

        <Box bg="dark.10" h={27} p={0} mt={10} pos="relative" style={{
        borderRadius: rem(5)
      }}>
          <Image src="/assets/info/avatar.png" w={103} h={88} mx="auto" pos="absolute" bottom={27} left={0} right={0} style={{
          zIndex: 10
        }} alt="avatar" />
          <Group h="100%" px={16}>
            <Box pos="relative" w="100%">
              <Progress radius={0} size="md" value={50} striped classNames={{
              root: classes.root,
              section: classes.sectionOne
            }} style={{
              zIndex: 1
            }} />
              <Progress radius={0} size="md" value={100} striped classNames={{
              root: classes.root,
              section: classes.sectionSecond
            }} pos="absolute" inset={0} />
            </Box>
          </Group>
        </Box>

        <Group mt={10} justify="end">
          <Text c="var(--text-dark)" fz={{
          base: 12,
          sm: 13
        }} fw={700} tt="uppercase">
            {i18n._('NEXT: LEVEL 3')}
          </Text>
        </Group>
      </Box>
    </Box>;
};